/**
 * JWTアクセストークン, リフレッシュトークン関連
 */
import moment from "moment";
import { refreshAccessToken } from "@/api/Login";

const accessTokenKey = "accessToken";
const accessTokenExpKey = "accessTokenExpiresAt";
const refreshTokenKey = "refreshToken";
const authCodeKey = "authCodeFlag";

export const hasAccessToken = (): boolean => {
  return !!localStorage.getItem(accessTokenKey);
};

export const getAccessToken = (): string | null => {
  return localStorage.getItem(accessTokenKey);
}

/**
 * 現在時刻がアクセストークン期限の `beforeSec` 秒前を過ぎていたら true
 */
export const needsRefresh = (): boolean => {
  const beforeSec = parseInt(process.env.VUE_APP_REFRESH_ACCESS_TOKEN_BEFORE_AT_SEC ?? "300");
  const exp = localStorage.getItem(accessTokenExpKey);
  if (!exp) {
    return false;
  }
  const expiresAt = moment(exp);
  const refreshesAt = expiresAt.clone().subtract(beforeSec, "seconds");
  return moment().isAfter(refreshesAt);
}

/**
 *  ローカルストレージの認証情報を更新する
 */
export const updateTokenPair = (accessToken: string, accessTokenExpiresAt: string, refreshToken: string) => {
  localStorage.setItem(accessTokenKey, accessToken);
  localStorage.setItem(accessTokenExpKey, accessTokenExpiresAt);
  localStorage.setItem(refreshTokenKey, refreshToken);
};


/**
 *  ローカルストレージの番号認証フラグを更新する
 */
export const updateAuthCodeFlag = (authCodeFlag:string) => {
  localStorage.setItem(authCodeKey, authCodeFlag);
};

/**
 *  ローカルストレージの番号認証フラグを取得する
 */
export const getAuthCodeFlag = ():boolean => {
  return JSON.parse(localStorage.getItem(authCodeKey)!.toLowerCase());
};

/**
 * localStorage の認証情報を削除する
 */
export const removeTokenPair = () => {
  localStorage.setItem(accessTokenKey, "");
  localStorage.setItem(accessTokenExpKey, "");
  localStorage.setItem(refreshTokenKey, "");
  localStorage.setItem(authCodeKey, "false");
};

/**
 * アクセストークン更新処理
 *
 * リフレッシュトークンを用いて新しいアクセストークン, 有効期限, リフレッシュトークンを取得
 * それらをlocalStorageに保存する
 */
export const refreshTokenPair = async (): Promise<void> => {
  const refreshToken = localStorage.getItem(refreshTokenKey);
  if (!refreshToken) {
    throw "refresh token not found";
  }
  const { refreshToken: newRefreshToken, accessToken, accessTokenExpiresAt } = await refreshAccessToken(refreshToken);
  updateTokenPair(accessToken, accessTokenExpiresAt, newRefreshToken);
};